import { Stack, Text } from "@mantine/core";

interface StatProps {
  readonly label: string;
  readonly value: string;
  readonly sub?: string;
}

export function Stat({ label, value, sub }: StatProps) {
  return (
    <Stack gap={2}>
      <Text size="sm" c="dimmed">
        {label}
      </Text>
      <Text fz={28} fw={600}>
        {value}
      </Text>
      {sub ? (
        <Text size="xs" c="dimmed">
          {sub}
        </Text>
      ) : null}
    </Stack>
  );
}
